import React from "react";
import { MapPin, Pencil, Camera } from "lucide-react";
import { CandidateAvatar } from "../CandidateAvatar";

// Compact header for "Mi Perfil Profesional" — priorities: name/title/location/status
// visible without scrolling, completion at a glance, one clear CTA. Never a giant card.
export function ProfileHeaderCard({ t, profile, user, onEditBasic, onOpenToWorkToggle, togglingAvailability, onCompleteProfile, onAvatarClick, completionHintText }) {
  const completion = profile?.completeness ?? 0;

  return (
    <div data-testid="profile-header-card" style={{ background: "white", border: "1px solid #E5E7EB", borderRadius: "16px", padding: "18px 20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
      <div className="flex items-start gap-3 sm:gap-4">
        <button type="button" onClick={onAvatarClick} data-testid="profile-avatar-edit-button" aria-label={t("profTab.avatarTitle")}
          style={{ position: "relative", flexShrink: 0, border: "none", background: "none", padding: 0, cursor: "pointer", borderRadius: "50%" }}>
          <CandidateAvatar name={profile?.name || user?.name} picture={profile?.picture} size={56} />
          <span style={{ position: "absolute", bottom: -2, right: -2, width: 20, height: 20, borderRadius: "50%", background: "#028CF8", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Camera style={{ width: 10, height: 10, color: "white" }} />
          </span>
        </button>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="flex items-start justify-between gap-2">
            <div style={{ minWidth: 0 }}>
              <h1 className="font-poppins font-bold text-slate-900 text-lg truncate" data-testid="profile-header-name">{profile?.name || user?.name || t("profTab.unnamedCandidate")}</h1>
              <p className="text-sm text-[#64748B] font-poppins line-clamp-2 leading-snug" data-testid="profile-header-title">{profile?.title || t("profile.addTitle")}</p>
            </div>
            <button type="button" onClick={onEditBasic} data-testid="profile-edit-basic-button" aria-label={t("profile.editProfile")}
              className="flex-shrink-0 h-8 w-8 rounded-lg border border-[#E5E7EB] flex items-center justify-center text-[#64748B] hover:bg-slate-50">
              <Pencil className="h-3.5 w-3.5" />
            </button>
          </div>

          {profile?.location && (
            <p className="text-xs text-[#94A3B8] font-poppins flex items-center gap-1 mt-1" data-testid="profile-header-location">
              <MapPin className="h-3 w-3" /> {profile.location}
            </p>
          )}

          <button type="button" onClick={onOpenToWorkToggle} disabled={togglingAvailability} data-testid="profile-availability-toggle"
            className="flex items-center gap-1.5 mt-2 text-xs font-poppins font-semibold" style={{ color: profile?.open_to_work ? "#10B981" : "#94A3B8" }}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: profile?.open_to_work ? "#10B981" : "#CBD5E1", flexShrink: 0 }} />
            {profile?.open_to_work ? t("profTab.availableStatus") : t("profTab.notAvailableStatus")}
          </button>
          <p className="text-[11px] text-[#94A3B8] font-poppins mt-1 leading-relaxed" data-testid="profile-availability-privacy-hint">
            {t("profTab.privacyHint")}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-xs font-semibold text-[#64748B] font-poppins">{t("profile.completeness")}</span>
          <span className="text-xs font-bold text-[#028CF8] font-poppins" data-testid="profile-completion-percent">{completion}%</span>
        </div>
        <div style={{ height: "6px", background: "#F1F5F9", borderRadius: "999px" }}>
          <div style={{ height: "100%", width: `${completion}%`, background: "#028CF8", borderRadius: "999px", transition: "width 0.3s ease" }} />
        </div>
        {completion < 100 && completionHintText && (
          <button type="button" onClick={onCompleteProfile} data-testid="profile-complete-cta"
            className="mt-2 text-xs font-bold text-[#028CF8] font-poppins hover:underline text-left">
            {completionHintText} →
          </button>
        )}
      </div>
    </div>
  );
}
